import { Component, Input } from '@angular/core';
import { Slide003Element } from 'src/assets/models/Slide003Element.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'package',
  templateUrl: './package.component.html',
  styleUrls: ['./package.component.scss']
})
export class PackageComponent {
  company = environment.company;

  @Input({required: true}) element: Slide003Element;

}
